export default "__VITE_ASSET__BTG0OrBo__"